import { render, staticRenderFns } from "./buildingRent.vue?vue&type=template&id=23e7bddf&scoped=true"
import script from "./buildingRent.vue?vue&type=script&lang=js"
export * from "./buildingRent.vue?vue&type=script&lang=js"
import style0 from "./buildingRent.vue?vue&type=style&index=0&id=23e7bddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7bddf",
  null
  
)

export default component.exports